import * as lib from './lib';
import { FlowType } from '../../shared/config';

const methodsForAvia = lib.methodsWithAppName(FlowType.AVIA);
const methodsForRw = lib.methodsWithAppName(FlowType.RAILWAYS);
const methodsForTours = lib.methodsWithAppName(FlowType.TOURS);

export * as freedomAppTypes from './types';
export { SupportedMiniApps } from './config';
export const freedomApp = {
  lib: {
    ...lib,
    avia: methodsForAvia,
    railways: methodsForRw,
    tours: methodsForTours,
  },
};
